import React, { useState } from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  CardMedia,
  Grid,
  Typography,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  MenuItem,
  Switch,
  Slider,
  Chip,
  Paper,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Select,
  FormControlLabel,
  Stepper,
  Step,
  StepLabel,
  InputAdornment,
  Checkbox,
} from "@mui/material";
import {
  AddCircleOutline,
  Close,
  ExpandMore,
  LocalGasStation,
  Speed,
  DirectionsCar,
  CloudUpload,
  CheckCircle,
  Language,
} from "@mui/icons-material";
import api from "../../../../features/auth/axiosConfig";
import Header from "../../../../shared/modules/header/Header";
import "./VechicleHome.css";
import Menu from "../../../../shared/modules/menu/Menu";

interface Vehicle {
  id: number;
  name: string;
  image: string;
  year: number;
  mileage: string;
  price: number;
  status: "For Sale" | "Sold";
  description: string;
  fuelType: string;
  power: string;
  drive: string;
  location: string;
  features?: string[];
}

type Language = "en" | "ar";

interface Translations {
  [key: string]: {
    [key: string]: string | { [key: string]: string };
  };
}

const translations: Translations = {
  en: {
    header: "Premium Vehicle Marketplace",
    heroTitle: "Discover Your Dream Vehicle",
    heroSubtitle: "Premium selection of luxury and performance vehicles",
    listYourVehicle: "List Your Vehicle",
    refineSearch: "Refine Your Search",
    clearAll: "Clear All",
    advancedFilters: "Advanced Filters",
    priceRange: "Price Range",
    vehicleType: "Vehicle Type",
    new: "New",
    certified: "Certified",
    preOwned: "Pre-Owned",
    features: "Features",
    sortBy: "Sort by:",
    priceLowToHigh: "Price: Low to High",
    priceHighToLow: "Price: High to Low",
    yearNewest: "Year: Newest First",
    yearOldest: "Year: Oldest First",
    showingResults: "Showing {count} vehicles",
    noVehiclesMatch: "No vehicles match your search criteria",
    resetFilters: "Reset Filters",
    viewDetails: "View Details",
    status: "Status",
    forSale: "For Sale",
    sold: "Sold",
    year: "Year",
    mileage: "Mileage",
    fuelType: "Fuel Type",
    power: "Power",
    drive: "Drive",
    location: "Location",
    description: "Description",
    close: "Close",
    contactSeller: "Contact Seller",
    buyNow: "Buy Now",
    listYourVehicleDialog: "List Your Vehicle",
    vehicleDetails: "Vehicle Details",
    photos: "Photos",
    pricing: "Pricing",
    review: "Review",
    make: "Make",
    model: "Model",
    uploadPhotos: "Upload Vehicle Photos",
    uploadInstructions:
      "Upload at least 3 photos (max 10). First image will be used as the cover.",
    selectPhotos: "Select Photos",
    mainImage: "Main",
    negotiable: "Price is negotiable",
    vehicleLocation: "Vehicle Location",
    city: "City",
    state: "State",
    reviewListing: "Review Your Listing",
    reviewInstructions:
      "Please review all the information before submitting your vehicle listing.",
    back: "Back",
    next: "Next",
    submitListing: "Submit Listing",
    quickFilters: {
      all: "All",
      luxury: "Luxury",
      suv: "SUV",
      sports: "Sports",
      electric: "Electric",
      hybrid: "Hybrid",
    },
  },
  ar: {
    header: "سوق المركبات الفاخرة",
    heroTitle: "اكتشف مركبتك الأحلام",
    heroSubtitle: "اختيار مميز من المركبات الفاخرة والعالية الأداء",
    listYourVehicle: "أضف مركبتك",
    refineSearch: "صقل بحثك",
    clearAll: "مسح الكل",
    advancedFilters: "فلاتر متقدمة",
    priceRange: "نطاق السعر",
    vehicleType: "نوع المركبة",
    new: "جديدة",
    certified: "معتمدة",
    preOwned: "مستعملة",
    features: "المميزات",
    sortBy: "ترتيب حسب:",
    priceLowToHigh: "السعر: من الأقل للأعلى",
    priceHighToLow: "السعر: من الأعلى للأقل",
    yearNewest: "السنة: الأحدث أولاً",
    yearOldest: "السنة: الأقدم أولاً",
    showingResults: "عرض {count} مركبة",
    noVehiclesMatch: "لا توجد مركبات تطابق معايير البحث الخاصة بك",
    resetFilters: "إعادة تعيين الفلاتر",
    viewDetails: "عرض التفاصيل",
    status: "الحالة",
    forSale: "للبيع",
    sold: "تم البيع",
    year: "السنة",
    mileage: "المسافة المقطوعة",
    fuelType: "نوع الوقود",
    power: "القوة",
    drive: "نظام الدفع",
    location: "الموقع",
    description: "الوصف",
    close: "إغلاق",
    contactSeller: "اتصل بالبائع",
    buyNow: "اشتر الآن",
    listYourVehicleDialog: "إضافة مركبة",
    vehicleDetails: "تفاصيل المركبة",
    photos: "الصور",
    pricing: "التسعير",
    review: "مراجعة",
    make: "الشركة المصنعة",
    model: "الموديل",
    uploadPhotos: "رفع صور المركبة",
    uploadInstructions:
      "قم بتحميل 3 صور على الأقل (10 كحد أقصى). سيتم استخدام الصورة الأولى كغلاف.",
    selectPhotos: "اختر الصور",
    mainImage: "رئيسية",
    negotiable: "السعر قابل للتفاوض",
    vehicleLocation: "موقع المركبة",
    city: "المدينة",
    state: "الولاية",
    reviewListing: "مراجعة الإعلان",
    reviewInstructions: "يرجى مراجعة جميع المعلومات قبل تقديم إعلان المركبة.",
    back: "السابق",
    next: "التالي",
    submitListing: "تقديم الإعلان",
    quickFilters: {
      all: "الكل",
      luxury: "فاخرة",
      suv: "دفع رباعي",
      sports: "رياضية",
      electric: "كهربائية",
      hybrid: "هجينة",
    },
  },
};

const VehicleHome: React.FC = () => {
  const [filters, setFilters] = useState({
    priceRange: [10000, 100000] as [number, number],
    types: {
      new: true,
      certified: true,
      preOwned: true,
    },
    features: [] as string[],
  });

  const [sortOption, setSortOption] = useState("price-asc");
  const [activeFilter, setActiveFilter] = useState("all");
  const [openAddDialog, setOpenAddDialog] = useState(false);
  const [openDetailsDialog, setOpenDetailsDialog] = useState(false);
  const [selectedVehicle, setSelectedVehicle] = useState<Vehicle | null>(null);
  const [addVehicleStep, setAddVehicleStep] = useState(0);
  const [uploadedImages, setUploadedImages] = useState<File[]>([]);
  const [currentLanguage, setCurrentLanguage] = useState<Language>("en");
  const [formData, setFormData] = useState({
    make: "",
    model: "",
    year: "",
    mileage: "",
    fuelType: "",
    description: "",
    price: "",
    status: "For Sale",
    negotiable: false,
    city: "",
    state: "",
  });

  const handleFormChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const t = (
    key: string,
    params?: { [key: string]: string | number }
  ): string => {
    let translation =
      translations[currentLanguage][key] || translations["en"][key] || key;

    if (typeof translation === "object") {
      return key;
    }

    let result = translation as string;

    if (params) {
      Object.keys(params).forEach((param) => {
        result = result.replace(`{${param}}`, params[param].toString());
      });
    }

    return result;
  };

  const toggleLanguage = () => {
    setCurrentLanguage(currentLanguage === "en" ? "ar" : "en");
  };

  const [vehicleData, setVehicleData] = useState<Vehicle[]>([
    {
      id: 1,
      image: "https://wallpapercave.com/wp/wp4412663.jpg",
      name: "BMW 850i xDrive",
      year: 2022,
      price: 55300,
      status: "For Sale",
      mileage: "7700 km",
      fuelType: "Petrol",
      power: "390 kW",
      drive: "4WD",
      location: "Budapest, HU",
      description: "A dream car for true connoisseurs of automotive art.",
      features: ["Leather Seats", "Sunroof", "Navigation", "Heated Seats"],
    },
    {
      id: 2,
      image: "https://wallpapercave.com/wp/wp12326190.jpg",
      name: "Audi RS7 Sportback",
      year: 2021,
      price: 87000,
      status: "For Sale",
      mileage: "12000 km",
      fuelType: "Petrol",
      power: "441 kW",
      drive: "AWD",
      location: "Munich, DE",
      description:
        "A luxury performance sedan with a sleek design and serious speed.",
      features: [
        "Sport Suspension",
        "LED Headlights",
        "Bang & Olufsen Sound",
        "Wireless Charging",
      ],
    },
    {
      id: 3,
      image:"https://wallpapercave.com/wp/wp6977981.jpg",
      name: "Mercedes-AMG GT Black Series",
      year: 2021,
      price: 16500,
      status: "Sold",
      mileage: "3500 km",
      fuelType: "Petrol",
      power: "537 kW",
      drive: "RWD",
      location: "Stuttgart, DE",
      description: "A beast on the track and a head-turner on the streets.",
      features: [
        "Carbon Fiber Roof",
        "Race Mode",
        "Active Aero",
        "Digital Cockpit",
      ],
    },
    {
      id: 4,
      image: "https://wallpapercave.com/wp/wp9204273.jpg",
      name: "Tesla Model S Plaid",
      year: 2023,
      price: 16800,
      status: "For Sale",
      mileage: "5000 km",
      fuelType: "Electric",
      power: "760 kW",
      drive: "AWD",
      location: "San Francisco, US",
      description:
        "Blazing fast acceleration meets cutting-edge technology in this electric beast.",
      features: [
        "Autopilot",
        "Glass Roof",
        "Touchscreen Console",
        "Smart Navigation",
      ],
    },
    {
      id: 5,
      image:"https://wallpapercave.com/wp/wp14846894.webp",
      name: "Lamborghini Huracán EVO",
      year: 2020,
      price: 21000,
      status: "Sold",
      mileage: "8000 km",
      fuelType: "Petrol",
      power: "470 kW",
      drive: "AWD",
      location: "Milan, IT",
      description:
        "Sharp lines, loud roars, and thrilling speed define this Italian masterpiece.",
      features: [
        "Sport Exhaust",
        "Carbon Ceramic Brakes",
        "Digital Cockpit",
        "Launch Control",
      ],
    },
  ]);

  const handleSubmitListing = async () => {
    try {
      // Create FormData object
      const formDataToSend = new FormData();
      
      // Append all form fields
      Object.entries(formData).forEach(([key, value]) => {
        formDataToSend.append(key, value.toString());
      });
      
      // Append uploaded images
      uploadedImages.forEach((image, index) => {
        // Change 'images' to 'image_file' to match backend expectations
        formDataToSend.append('image_file', image);
        if (index === 0) {
          formDataToSend.append('mainImageIndex', '0');
        }
      });
      
      // Make API call
      const res = await api.post(`/pos/vehicle`, formDataToSend, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      
      // Handle success
      if (res.status === 200 || res.status === 201) {
        // Add the new vehicle to the local state
        setVehicleData(prev => [...prev, res.data]);
        // Close the dialog and reset form
        handleCloseAddDialog();
      }
    } catch (error) {
      console.error("Error submitting vehicle:", error);
    }
  };
  

  const filteredVehicles = vehicleData
  .filter((vehicle) => {
    if (!vehicle || vehicle.price == null) {
      return false;
    }

    const withinPriceRange =
      vehicle.price >= filters.priceRange[0] &&
      vehicle.price <= filters.priceRange[1];

    const statusMatch =
      (filters.types.new && vehicle.status === "For Sale") ||
      (filters.types.preOwned && vehicle.status === "Sold");

    const featuresMatch =
      filters.features.length === 0 ||
      (vehicle.features &&
        filters.features.every((f) => vehicle.features?.includes(f)));

    return withinPriceRange && statusMatch && featuresMatch;
  })
  .sort((a, b) => {
    switch (sortOption) {
      case "price-asc":
        return a.price - b.price;
      case "price-desc":
        return b.price - a.price;
      case "year-newest":
        return b.year - a.year;
      case "year-oldest":
        return a.year - b.year;
      default:
        return 0;
    }
  });


  const handlePriceChange = (event: Event, newValue: number | number[]) => {
    setFilters((prev) => ({
      ...prev,
      priceRange: newValue as [number, number],
    }));
  };

  const handleViewDetails = (vehicle: Vehicle) => {
    setSelectedVehicle(vehicle);
    setOpenDetailsDialog(true);
  };

  const handleAddVehicle = () => {
    setOpenAddDialog(true);
  };

  const handleCloseAddDialog = () => {
    setOpenAddDialog(false);
    setAddVehicleStep(0);
    setUploadedImages([]);
    setFormData({
      make: "",
      model: "",
      year: "",
      mileage: "",
      fuelType: "",
      description: "",
      price: "",
      status: "For Sale",
      negotiable: false,
      city: "",
      state: "",
    });
  };

  const handleNextStep = () => {
    setAddVehicleStep((prev) => prev + 1);
  };

  const handlePrevStep = () => {
    setAddVehicleStep((prev) => prev - 1);
  };

  const handleImageUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files) {
      const files = Array.from(e.target.files);
      setUploadedImages((prev) => [...prev, ...files]);
    }
  };

  const handleRemoveImage = (index: number) => {
    setUploadedImages((prev) => prev.filter((_, i) => i !== index));
  };

  const allFeatures = [
    "Leather Seats",
    "Sunroof",
    "Navigation",
    "Backup Camera",
    "Heated Seats",
    "Apple CarPlay",
    "Android Auto",
    "Blind Spot Monitoring",
  ];

  const direction = currentLanguage === "ar" ? "rtl" : "ltr";

  return (
    <div className="vehicle-marketplace-container" dir={direction}>
      <Header Header={t("header")} />
      <div style={{ display: "flex" }}>
        <Menu />
        <Box className="vehicle-marketplace-content">

          {/* <Box className="language-switcher">
            <Button
              variant="contained"
              onClick={toggleLanguage}
              startIcon={<Language />}
              className="language-button"
            >
              {currentLanguage === "en" ? "العربية" : "English"}
            </Button>
          </Box> */}

          <Box className="marketplace-hero">
            <Typography variant="h2" className="hero-title">
              {t("heroTitle")}
            </Typography>
            <Typography variant="h6" className="hero-subtitle">
              {t("heroSubtitle")}
            </Typography>
            <Button
              variant="contained"
              startIcon={<AddCircleOutline />}
              onClick={handleAddVehicle}
              className="hero-cta-button"
            >
              {t("listYourVehicle")}
            </Button>
          </Box>

          {/* Filter Section */}
          <Paper elevation={1} className="filter-section">
            <Box className="filter-header">
              <Typography variant="h5" className="filter-title">
                {t("refineSearch")}
              </Typography>
              <Button
                variant="text"
                onClick={() =>
                  setFilters({
                    priceRange: [10000, 100000],
                    types: { new: true, certified: true, preOwned: true },
                    features: [],
                  })
                }
                className="clear-filters-button"
              >
                {t("clearAll")}
              </Button>
            </Box>

            {/* Quick Filters */}
            <Box className="quick-filters">
              {["all", "luxury", "suv", "sports", "electric", "hybrid"].map(
                (filter) => (
                  <Chip
                    key={filter}
                    label={t(`${filter}`)}
                    onClick={() => setActiveFilter(filter)}
                    className={`quick-filter-chip ${
                      activeFilter === filter ? "active" : ""
                    }`}
                  />
                )
              )}
            </Box>

            {/* Advanced Filters */}
            <Accordion className="advanced-filters-accordion">
              <AccordionSummary expandIcon={<ExpandMore />}>
                <Typography>{t("advancedFilters")}</Typography>
              </AccordionSummary>
              <AccordionDetails
                sx={{ px: 1, py: 0.5, "& .MuiGrid-item": { mb: 1 } }}
              >
                <Grid container spacing={3}>
                  {/* Price Range */}
                  <Grid item xs={12} md={3}>
                    <Typography variant="subtitle1" gutterBottom>
                      {t("priceRange")}
                    </Typography>
                    <Slider
                      value={filters.priceRange}
                      onChange={handlePriceChange}
                      valueLabelDisplay="auto"
                      min={10000}
                      max={100000}
                      step={1000}
                      valueLabelFormat={(value) => `$${value.toLocaleString()}`}
                      className="price-range-slider"
                    />
                    <Box className="price-inputs">
                      <TextField
                        size="small"
                        label={t("priceLowToHigh").split(":")[0]}
                        value={filters.priceRange[0]}
                        onChange={(e) =>
                          setFilters((prev) => ({
                            ...prev,
                            priceRange: [
                              Number(e.target.value),
                              prev.priceRange[1],
                            ],
                          }))
                        }
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">$</InputAdornment>
                          ),
                        }}
                        className="price-input"
                      />
                      <TextField
                        size="small"
                        label={t("priceHighToLow").split(":")[0]}
                        value={filters.priceRange[1]}
                        onChange={(e) =>
                          setFilters((prev) => ({
                            ...prev,
                            priceRange: [
                              prev.priceRange[0],
                              Number(e.target.value),
                            ],
                          }))
                        }
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">$</InputAdornment>
                          ),
                        }}
                        className="price-input"
                      />
                    </Box>
                  </Grid>

                  {/* Vehicle Type */}
                  <Grid item xs={12} md={4}>
                    <Typography variant="subtitle1" gutterBottom>
                      {t("vehicleType")}
                    </Typography>
                    <Box className="type-filters">
                      <FormControlLabel
                        control={
                          <Switch
                            checked={filters.types.new}
                            onChange={() =>
                              setFilters((prev) => ({
                                ...prev,
                                types: { ...prev.types, new: !prev.types.new },
                              }))
                            }
                          />
                        }
                        label={t("new")}
                        className="type-filter"
                      />
                      <FormControlLabel
                        control={
                          <Switch
                            checked={filters.types.certified}
                            onChange={() =>
                              setFilters((prev) => ({
                                ...prev,
                                types: {
                                  ...prev.types,
                                  certified: !prev.types.certified,
                                },
                              }))
                            }
                          />
                        }
                        label={t("certified")}
                        className="type-filter"
                      />
                      <FormControlLabel
                        control={
                          <Switch
                            checked={filters.types.preOwned}
                            onChange={() =>
                              setFilters((prev) => ({
                                ...prev,
                                types: {
                                  ...prev.types,
                                  preOwned: !prev.types.preOwned,
                                },
                              }))
                            }
                          />
                        }
                        label={t("preOwned")}
                        className="type-filter"
                      />
                    </Box>
                  </Grid>

                  {/* Features */}
                  <Grid item xs={12}>
                    <Typography variant="subtitle1" gutterBottom>
                      {t("features")}
                    </Typography>
                    <Box className="feature-chips-container">
                      {allFeatures.map((feature) => (
                        <Chip
                          key={feature}
                          label={feature}
                          onClick={() =>
                            setFilters((prev) => ({
                              ...prev,
                              features: prev.features.includes(feature)
                                ? prev.features.filter((f) => f !== feature)
                                : [...prev.features, feature],
                            }))
                          }
                          className={`feature-chip ${
                            filters.features.includes(feature) ? "selected" : ""
                          }`}
                          deleteIcon={<CheckCircle />}
                          onDelete={() => {}}
                        />
                      ))}
                    </Box>
                  </Grid>
                </Grid>
              </AccordionDetails>
            </Accordion>

            {/* Sort Options */}
            <Box className="sort-options">
              <Typography variant="body1">{t("sortBy")}</Typography>
              <Select
                value={sortOption}
                onChange={(e) => setSortOption(e.target.value as string)}
                className="sort-select"
              >
                <MenuItem value="price-asc">{t("priceLowToHigh")}</MenuItem>
                <MenuItem value="price-desc">{t("priceHighToLow")}</MenuItem>
                <MenuItem value="year-newest">{t("yearNewest")}</MenuItem>
                <MenuItem value="year-oldest">{t("yearOldest")}</MenuItem>
              </Select>
            </Box>
          </Paper>

          {/* Vehicle Grid */}
          <Box className="vehicle-grid-section">
            <Typography variant="h5" className="results-count">
              {t("showingResults", { count: filteredVehicles.length })}
            </Typography>

            {filteredVehicles.length > 0 ? (
              <Grid container spacing={4} className="vehicle-grid">
                {filteredVehicles.map((vehicle) => (
                  <Grid item xs={12} sm={6} md={4} key={vehicle.id}>
                    <Card className="vehicle-card">
                      <Box className="card-media-wrapper">
                        <CardMedia
                          component="img"
                          image={vehicle.image}
                          alt={vehicle.name}
                          className="vehicle-image"
                        />
                        <Chip
                          label={t(
                            vehicle.status.toLowerCase().replace(" ", "")
                          )}
                          className={`status-chip ${
                            vehicle.status === "For Sale" ? "available" : "sold"
                          }`}
                        />
                      </Box>
                      <CardContent className="vehicle-card-content">
                        <Box className="vehicle-header">
                          <Typography variant="h6" className="vehicle-title">
                            {vehicle.name}
                          </Typography>
                          <Typography
                            variant="body2"
                            className="vehicle-year-mileage"
                          >
                            {vehicle.year} • {vehicle.mileage}
                          </Typography>
                        </Box>

                        <Box className="vehicle-specs">
                          <Box className="spec-item">
                            <LocalGasStation fontSize="small" />
                            <Typography variant="body2">
                              {vehicle.fuelType}
                            </Typography>
                          </Box>
                          <Box className="spec-item">
                            <Speed fontSize="small" />
                            <Typography variant="body2">
                              {vehicle.power}
                            </Typography>
                          </Box>
                          <Box className="spec-item">
                            <DirectionsCar fontSize="small" />
                            <Typography variant="body2">
                              {vehicle.drive}
                            </Typography>
                          </Box>
                        </Box>

                        <Typography className="vehicle-price">
                          ${vehicle.price.toLocaleString()}
                        </Typography>

                        <Button
                          variant="contained"
                          fullWidth
                          className="view-details-button"
                          onClick={() => handleViewDetails(vehicle)}
                        >
                          {t("viewDetails")}
                        </Button>
                      </CardContent>
                    </Card>
                  </Grid>
                ))}
              </Grid>
            ) : (
              <Box className="no-results">
                <Typography variant="h6">{t("noVehiclesMatch")}</Typography>
                <Button
                  variant="outlined"
                  onClick={() =>
                    setFilters({
                      priceRange: [10000, 100000],
                      types: { new: true, certified: true, preOwned: true },
                      features: [],
                    })
                  }
                  className="reset-filters-button"
                >
                  {t("resetFilters")}
                </Button>
              </Box>
            )}
          </Box>
        </Box>
      </div>

      {/* Vehicle Details Dialog */}
      <Dialog
        open={openDetailsDialog}
        onClose={() => setOpenDetailsDialog(false)}
        maxWidth="md"
        fullWidth
        className="vehicle-details-dialog"
      >
        {selectedVehicle && (
          <>
            <DialogTitle className="dialog-title">
              <Typography variant="h4">{selectedVehicle.name}</Typography>
              <IconButton
                onClick={() => setOpenDetailsDialog(false)}
                className="close-button"
              >
                <Close />
              </IconButton>
            </DialogTitle>
            <DialogContent dividers className="dialog-content">
              <Grid container spacing={4}>
                <Grid item xs={12} md={6}>
                  <Box className="image-gallery">
                    <CardMedia
                      component="img"
                      image={selectedVehicle.image}
                      alt={selectedVehicle.name}
                      className="main-image"
                    />
                    <Box className="thumbnail-container">
                      <CardMedia
                        component="img"
                        image={selectedVehicle.image}
                        alt="Thumbnail"
                        className="thumbnail"
                      />
                      <CardMedia
                        component="img"
                        image={selectedVehicle.image}
                        alt="Thumbnail"
                        className="thumbnail"
                      />
                      <CardMedia
                        component="img"
                        image={selectedVehicle.image}
                        alt="Thumbnail"
                        className="thumbnail"
                      />
                    </Box>
                  </Box>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Box className="vehicle-details">
                    <Typography variant="h5" className="price">
                      ${selectedVehicle.price.toLocaleString()}
                    </Typography>
                    <Typography variant="body1" className="status">
                      {t("status")}:{" "}
                      <span>
                        {t(
                          selectedVehicle.status.toLowerCase().replace(" ", "")
                        )}
                      </span>
                    </Typography>

                    <Box className="details-grid">
                      {[
                        [t("year"), selectedVehicle.year],
                        [t("mileage"), selectedVehicle.mileage],
                        [t("fuelType"), selectedVehicle.fuelType],
                        [t("power"), selectedVehicle.power],
                        [t("drive"), selectedVehicle.drive],
                        [t("location"), selectedVehicle.location],
                      ].map(([label, value], index) => (
                        <Box key={index} className="detail-item">
                          <Typography variant="body1" className="detail-label">
                            {label}:
                          </Typography>
                          <Typography variant="body1" className="detail-value">
                            {value}
                          </Typography>
                        </Box>
                      ))}
                    </Box>

                    {selectedVehicle.features &&
                      selectedVehicle.features.length > 0 && (
                        <Box className="features-section">
                          <Typography variant="h6">{t("features")}</Typography>
                          <Box className="features-list">
                            {selectedVehicle.features.map((feature, index) => (
                              <Chip
                                key={index}
                                label={feature}
                                className="feature-tag"
                              />
                            ))}
                          </Box>
                        </Box>
                      )}
                  </Box>
                </Grid>
                <Grid item xs={12}>
                  <Typography variant="h6">{t("description")}</Typography>
                  <Typography variant="body1" className="full-description">
                    {selectedVehicle.description}
                  </Typography>
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions className="dialog-actions">
              <Button
                variant="outlined"
                onClick={() => setOpenDetailsDialog(false)}
                className="action-button"
              >
                {t("close")}
              </Button>
              <Button
                variant="contained"
                className="action-button primary"
                disabled={selectedVehicle.status !== "For Sale"}
              >
                {t("contactSeller")}
              </Button>
              <Button
                variant="contained"
                className="action-button buy-now"
                disabled={selectedVehicle.status !== "For Sale"}
              >
                {t("buyNow")}
              </Button>
            </DialogActions>
          </>
        )}
      </Dialog>

      {/* Add Vehicle Dialog */}
      <Dialog
        open={openAddDialog}
        onClose={handleCloseAddDialog}
        maxWidth="md"
        fullWidth
        className="add-vehicle-dialog"
      >
        <DialogTitle className="dialog-title">
          <Typography variant="h4">{t("listYourVehicleDialog")}</Typography>
          <IconButton onClick={handleCloseAddDialog} className="close-button">
            <Close />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers className="dialog-content">
          <Stepper
            activeStep={addVehicleStep}
            alternativeLabel
            className="form-stepper"
          >
            {[t("vehicleDetails"), t("photos"), t("pricing"), t("review")].map(
              (label) => (
                <Step key={label}>
                  <StepLabel>{label}</StepLabel>
                </Step>
              )
            )}
          </Stepper>

          {addVehicleStep === 0 && (
            <Grid container spacing={3} className="form-step-content">
              <Grid item xs={12} sm={6}>
                <TextField
                  label={t("make")}
                  fullWidth
                  variant="outlined"
                  className="form-field"
                  name="make"
                  value={formData.make}
                  onChange={handleFormChange}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  label={t("model")}
                  fullWidth
                  variant="outlined"
                  className="form-field"
                  name="model"
                  value={formData.model}
                  onChange={handleFormChange}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  label={t("year")}
                  type="number"
                  fullWidth
                  variant="outlined"
                  className="form-field"
                  name="year"
                  value={formData.year}
                  onChange={handleFormChange}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  label={t("mileage")}
                  type="number"
                  fullWidth
                  variant="outlined"
                  className="form-field"
                  name="mileage"
                  value={formData.mileage}
                  onChange={handleFormChange}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  label={t("fuelType")}
                  select
                  fullWidth
                  variant="outlined"
                  className="form-field"
                  name="fuelType"
                  value={formData.fuelType}
                  onChange={handleFormChange}
                >
                  {["Petrol", "Diesel", "Electric", "Hybrid", "Other"].map(
                    (option) => (
                      <MenuItem key={option} value={option}>
                        {option}
                      </MenuItem>
                    )
                  )}
                </TextField>
              </Grid>
              <Grid item xs={12}>
                <TextField
                  label={t("description")}
                  multiline
                  rows={4}
                  fullWidth
                  variant="outlined"
                  className="form-field"
                />
              </Grid>
            </Grid>
          )}

          {addVehicleStep === 1 && (
            <Box className="upload-photos-section">
              <Typography variant="h6">{t("uploadPhotos")}</Typography>
              <Typography variant="body2" color="textSecondary">
                {t("uploadInstructions")}
              </Typography>

              <input
                accept="image/*"
                id="vehicle-image-upload"
                type="file"
                multiple
                onChange={handleImageUpload}
                style={{ display: "none" }}
              />
              <label htmlFor="vehicle-image-upload">
                <Button
                  variant="outlined"
                  component="span"
                  startIcon={<CloudUpload />}
                  className="upload-button"
                >
                  {t("selectPhotos")}
                </Button>
              </label>

              {uploadedImages.length > 0 && (
                <Box className="image-preview-container">
                  {uploadedImages.map((img, index) => (
                    <Box key={index} className="image-preview-wrapper">
                      <CardMedia
                        component="img"
                        src={URL.createObjectURL(img)}
                        alt={`Preview ${index + 1}`}
                        className="image-preview"
                      />
                      {index === 0 && (
                        <Chip
                          label={t("mainImage")}
                          size="small"
                          className="main-image-label"
                        />
                      )}
                      <IconButton
                        size="small"
                        onClick={() => handleRemoveImage(index)}
                        className="remove-image-button"
                      >
                        <Close fontSize="small" />
                      </IconButton>
                    </Box>
                  ))}
                </Box>
              )}
            </Box>
          )}

          {addVehicleStep === 2 && (
            <Grid container spacing={3} className="form-step-content">
              <Grid item xs={12} sm={6}>
                <TextField
                  label={t("price")}
                  type="number"
                  fullWidth
                  variant="outlined"
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">$</InputAdornment>
                    ),
                  }}
                  className="form-field"
                  name="price"
                  value={formData.price}
                  onChange={handleFormChange}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  label={t("status")}
                  select
                  fullWidth
                  variant="outlined"
                  className="form-field"
                  name="status"
                  value={formData.status}
                  onChange={handleFormChange}
                >
                  <MenuItem value="For Sale">{t("forSale")}</MenuItem>
                  <MenuItem value="Sold">{t("sold")}</MenuItem>
                </TextField>
              </Grid>
              <Grid item xs={12}>
                <FormControlLabel
                  control={<Checkbox />}
                  label={t("negotiable")}
                  className="negotiable-checkbox"
                />
              </Grid>
              <Grid item xs={12}>
                <Typography variant="subtitle1">
                  {t("vehicleLocation")}
                </Typography>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      label={t("city")}
                      fullWidth
                      variant="outlined"
                      className="form-field"
                      name="city"
                      value={formData.city}
                      onChange={handleFormChange}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      label={t("state")}
                      fullWidth
                      variant="outlined"
                      className="form-field"
                      name="state"
                      value={formData.state}
                      onChange={handleFormChange}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          )}

          {addVehicleStep === 3 && (
            <Box className="review-section">
              <Typography variant="h6">{t("reviewListing")}</Typography>
              <Typography variant="body1">{t("reviewInstructions")}</Typography>
            </Box>
          )}
        </DialogContent>
        <DialogActions className="dialog-actions">
          {addVehicleStep > 0 && (
            <Button onClick={handlePrevStep} className="action-button">
              {t("back")}
            </Button>
          )}
          {addVehicleStep < 3 ? (
            <Button
              onClick={handleNextStep}
              variant="contained"
              className="action-button primary"
            >
              {t("next")}
            </Button>
          ) : (
            <Button variant="contained" className="action-button submit" onClick={handleSubmitListing}>
              {t("submitListing")}
            </Button>
          )}
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default VehicleHome;
